// extracted by mini-css-extract-plugin
export default {"container":"two-factor_container__FXjQU","title":"two-factor_title__OmIsf","body":"two-factor_body__+0Zwf"};